// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { APP_BASE_HREF } from "@angular/common";
export const environment = {
    production: true,
    appVersion: "v1.0.0",
    USERDATA_KEY: "authf649fc9a5f55",
    isMockEnabled: true,
    is_mobile: window.innerWidth <= 991 ? true : false,

    apiUrl: "https://cmcs-digital.com/api",
    imageUrl: "https://cmcs-digital.com/",
    // apiUrl: "http://72.61.82.21/api",
    // imageUrl: "http://72.61.82.21/",
    // apiUrl: "http://127.0.0.1:8000/api",
    // imageUrl: "http://127.0.0.1:8000/",
    // apiUrl: "https://cmcs-digital.com/api",
    // imageUrl: "https://cmcs-digital.com/",
    appThemeName: "assit-managment-system",
    // apiUrl: 'mysite.com/api',
    appDemos: {
        "assit-managment-system": {
            title: "assit-managment-system",
            description: "Default Dashboard",
            published: true,
            thumbnail: "./assets/media/logos/hrl-billing.png",
        },
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
